/*eslint-disable */
const $ = window.jQuery = require('jquery');

import Push from 'push.js';
import audioPlay from '@/assets/audio/videocall_ringtone.mp3';
import {bus} from '@/main';
import commonSocket from "@/services/commonSocket/";
import supportChatbot from '@/components/private/support-chatbot';
import videoCallNotification from '@/components/private/video-call-notification-popup/';

var audioPlayer;
export default {
  name: 'dashboard',
  components: {
    'support-chatbot' : supportChatbot,
    'video-call' : videoCallNotification,
  },
  props: [],
  data () {
    return {
      selfUserId:'',
      incomingCallNotification:false,
      callerInfo:'',
      userIDforVideoCall:'',
      videoCallerUserId:'',
      roomId:''
    }
  },
  computed: {

  },
  mounted () {
    if(!localStorage.getItem('token')){
      this.$router.push('/');
    }
    this.$store.dispatch('getAuthHeader');
    bus.$emit('showHeaderbtn', true);

    if(localStorage.getItem('LoginedUserID')){
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }

    setTimeout(() => {
      document.getElementById("preloader").style.display = "none";
    }, 200);

    bus.$on('callerNotifiactionBus', (data) => {
      this.incomingCallNotification = data;
    });

    
    this.commonSocketFun();
    
    bus.$on('newChatMessage', (data) => {
      const payload = {
        type: "newChatMessage",
        chatRoomId: data.chatRoomId,
        message: data.message,
        senderName: data.senderName
      };
      commonSocket.emit(payload);
    });
  },
  methods: {
    playSound (sound) {
      if(sound) {
        audioPlayer = new Audio(sound);
        audioPlayer.play();
      }
    },
    stopSound () {
      if(audioPlayer == undefined) return; 
      audioPlayer.pause();
    },
    commonSocketFun(){
      let callerID = '3548d149becb44e9LBIL';
      commonSocket.connect(callerID);
      commonSocket.$on('connection', response => {
        const payload = {
          type: "userLogin",
          userID: this.selfUserId,
          message: "User Login"
        };
        commonSocket.emit(payload);
      });
      commonSocket.$on('userLogin', this.handleUserLogin);
      // commonSocket.$on('userStatus', this.handleSelfUserStatus);
      // commonSocket.$on('selfUserStatus', this.handleAllUserStatus);
      commonSocket.$on('TypingEventForSelectedUserNotification', this.handleTypingEventNotification)
      commonSocket.$on('videoCallingNotification', this.handleVideoCallMethod);
      commonSocket.$on('videoCallAlertPopupClosed', this.callerPopupClosedInOtherTabs);
      commonSocket.$on('newMessageNotifications', this.handleNewMessageNotification);
      commonSocket.$on('userLogout', this.handleUserLogout);
    },

    handleUserLogin(response) {
      try {
        const payload = {
          userID: response.userID,
          is_online: true,
        };
        bus.$emit('userUpdateStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
    
    handleUserLogout(response) {
      try {
        const payload = {
          userID: response.userID,
          is_online: false,
        };
        bus.$emit('userUpdateStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
    
    handleNewMessageNotification(response) {
        bus.$emit('updateMessageNotification', response);
        bus.$emit('updateMessageNotifications', response);
    },

    handleTypingEventNotification(response){
      bus.$emit('typingEventForChatBus', response);
    },

    handleVideoCallMethod(getData){
      if(this.selfUserId == getData.targetId){
        if(Push.Permission.has()){
          Push.create('LBIL Video Call From ' + getData.callerName, {
            body:'Check Your LBIL to answer',
            timeout:5000,
            onClick: function () {
                window.focus();
                this.close();
            }
          })
        }
        document.body.classList.add('videoNotificationPopup');
        this.callerInfo = getData
        this.roomId = getData.roomId;
        this.incomingCallNotification = true
        // this.playSound(audioPlay)
      }
    },
    callerPopupClosedInOtherTabs(closeOtherTabData){
      if(this.selfUserId != closeOtherTabData.videoCallRoomId) return;
      if(closeOtherTabData.type == 'videoAlertPopupClose'){
        this.stopSound()
        document.body.classList.remove('videoNotificationPopup');
        this.callerInfo = null;
        this.incomingCallNotification = false
      }
    },
    closeSocket() {
      if(commonSocket.isOpen()) {
        commonSocket.close();
      }
    },
  },

  beforeMount() {
    window.addEventListener("beforeunload", this.closeSocket)
  },

  beforeDestroy() {
    if(commonSocket.isOpen()) {
      commonSocket.close();
    }
    window.removeEventListener("beforeunload", this.closeSocket);
  },

  beforeCreate: function() {
    document.body.classList.add('dashboard');
  },
  
  beforeRouteLeave: function (to, from, next) {
    document.body.classList.remove('dashboard');
    next();
  },
}